<script>
  export let heading;
</script>

<div class="heading">
  <h2 class="h3 heading__title">{heading.title}</h2>
  {#if heading.desc}
    <p class="text-small heading__desc">{heading.desc}</p>
  {/if}
</div>

<style lang="scss">
  .heading {
    max-width: 78rem;
    margin: 10rem auto 0;
    text-align: center;

    &__title {
    }

    &__desc {
      margin: 1.8rem auto 0;
      max-width: 40rem;
      color: var(--royal-light);
    }
  }
</style>
